import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ReusableFunctions} from "app/modules/shared/classes/reusable-functions";
import {ScheduledReportsService} from "app/modules/shared/services/scheduled-reports.service";
import {ToastService} from "app/modules/shared/services/toast.service";

@Component({
  selector: 'app-display-options-dialog',
  templateUrl: './display-options-dialog.component.html',
  styleUrls: ['./display-options-dialog.component.scss']
})
export class DisplayOptionsDialogComponent implements OnInit {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private reusableFunctions: ReusableFunctions,
      private scheduledReportService: ScheduledReportsService,
      private dialogRef: MatDialogRef<DisplayOptionsDialogComponent>,
      private toastService: ToastService
  ) { }


  ngOnInit() {
    
  }

  applyDisplayOptions(event) {}

}
